import axios from "axios";
import Cookies from "js-cookie";
import { OLD_PERCENTAGE_DATE_KEY, PERCENTAGE_CACHE } from "../config/key";
import { HTTP_REST_URLS } from "../config/urls";
import { useApiMiddleware } from "./useApiMiddleware"

export const useUpdatePercentage = (headers) => new Promise(async (resolve, reject) => { 
   
    const url = HTTP_REST_URLS.UPDATE_PERCENTAGE; 

    const result = localStorage.getItem(PERCENTAGE_CACHE); 
    console.log( window.currentCacheData, ' window.currentCacheData');
 

    if (typeof window.currentCacheData !== "undefined") { 
        let item = { ...window.currentCacheData }; 
        item.material_id = item.material_id || item.id; 
        item.topic_id = ""; 
        item.medium = ""; 
        
      
        item.material_percentage = item?.is_locked ? "0" : (window.currentCacheData?.material_percentage || "0"); 
        
        // Ensure material_percentage is a string as your backend might expect it.
        item.material_percentage = String(item.material_percentage);
        
        try {
            const encodedHeaders = headers ? Object.entries(headers).reduce((acc, [key, value]) => {
              acc[key] = encodeURIComponent(value);
              return acc;
            }, {}) : {};

            const response = await axios.post(url, item, {
                headers: encodedHeaders,
            });
         
            if (!response.data.error) 
            {
                if(response?.data?.total_percentage != undefined)
                {
                    let updatedPercetange = response.data.total_percentage;
                    window.updateMaterialProgress(updatedPercetange);
                    Cookies.set(OLD_PERCENTAGE_DATE_KEY, new Date());
                }
            }
            resolve(response);
        } catch (error) {
            reject(error);
        }
    }
});